import React, { useEffect } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const goBack = () => {
    window.location.hash = '';
  };
  return <div className="min-h-screen bg-white text-black" data-id="element-678">
      <div className="max-w-3xl mx-auto px-4 py-12 md:py-20" data-id="element-679">
        <button onClick={goBack} className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-primary transition-colors mb-8" data-id="element-680">
          <ArrowLeftIcon size={16} data-id="element-681" />
          Back to Home
        </button>

        <h1 className="text-3xl md:text-4xl font-black text-black mb-2" data-id="element-682">
          Terms &amp; Conditions
        </h1>
        <p className="text-sm text-gray-400 mb-10" data-id="element-683">
          Last updated: 16 March 2026
        </p>

        <div className="prose prose-gray max-w-none space-y-8 text-sm md:text-base leading-relaxed text-gray-700" data-id="element-684">
          <section data-id="element-685">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-686">
              1. Introduction
            </h2>
            <p data-id="element-687">
              These Terms and Conditions ("Terms") govern your use of the
              services provided by <strong data-id="element-688">Strattigize</strong> ("Company",
              "we", "us", or "our"), accessible via our website and related
              platforms. By subscribing to or using any of our services, you
              ("Client", "you", or "your") agree to be bound by these Terms in
              their entirety.
            </p>
            <p data-id="element-689">
              These Terms constitute a legally binding agreement between you and
              the Company, governed by the laws of the Republic of India,
              including but not limited to the Indian Contract Act, 1872, the
              Information Technology Act, 2000, and the Consumer Protection Act,
              2019.
            </p>
          </section>

          <section data-id="element-690">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-691">
              2. Definitions
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-692">
              <li data-id="element-693">
                <strong data-id="element-694">"Services"</strong> refers to website development, SEO
                optimisation, CRM setup, lead tracking, AI chatbot deployment,
                AI receptionist services, automated review management,
                appointment booking automation, and any other digital marketing
                or automation services offered by Strattigize.
              </li>
              <li data-id="element-695">
                <strong data-id="element-696">"Subscription"</strong> refers to the recurring monthly
                payment plan selected by the Client (Starter, Unlimited, or
                Pro).
              </li>
              <li data-id="element-697">
                <strong data-id="element-698">"Deliverables"</strong> refers to the digital assets,
                configurations, and systems created or deployed as part of the
                Services.
              </li>
            </ul>
          </section>

          <section data-id="element-699">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-700">
              3. Eligibility
            </h2>
            <p data-id="element-701">
              You must be at least 18 years of age and legally competent to
              enter into a binding contract under the Indian Contract Act, 1872.
              By using our Services, you represent and warrant that you meet
              these requirements and have the authority to bind the business
              entity on whose behalf you are subscribing.
            </p>
          </section>

          <section data-id="element-702">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-703">
              4. Services &amp; Subscription Plans
            </h2>
            <p data-id="element-704">
              We offer the following subscription plans, each billed monthly
              with no setup cost:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-705">
              <li data-id="element-706">
                <strong data-id="element-707">Starter (£97/month):</strong> Free website, on-page SEO,
                SSL &amp; fast loading, lead capture system.
              </li>
              <li data-id="element-708">
                <strong data-id="element-709">Unlimited (£297/month):</strong> Everything in Starter
                plus CRM &amp; lead tracking, SMS/email/review automations,
                Google 5-star reviews automation, and 24/7 live AI chatbot.
              </li>
              <li data-id="element-710">
                <strong data-id="element-711">Pro (£497/month):</strong> Everything in Unlimited plus
                24/7 live AI receptionist and automatic appointment booking
                automation.
              </li>
            </ul>
            <p data-id="element-712">
              The Company reserves the right to modify, update, or discontinue
              any plan or feature at any time with reasonable prior notice to
              existing subscribers.
            </p>
          </section>

          <section data-id="element-713">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-714">
              5. Payment Terms
            </h2>
            <p data-id="element-715">
              All payments are processed through PayPal or other payment
              gateways as specified. By subscribing, you authorise recurring
              monthly charges to your selected payment method. Payments are due
              on the same date each month as the initial subscription date.
            </p>
            <p data-id="element-716">
              All fees are quoted in British Pounds Sterling (GBP). You are
              responsible for any currency conversion fees, bank charges, or
              taxes applicable in your jurisdiction.
            </p>
            <p data-id="element-717">
              Failure to make timely payments may result in suspension or
              termination of Services without prior notice.
            </p>
          </section>

          <section data-id="element-718">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-719">
              6. Intellectual Property
            </h2>
            <p data-id="element-720">
              All intellectual property rights in the Deliverables, including
              but not limited to website designs, code, automation workflows, AI
              configurations, and marketing materials, shall remain the
              exclusive property of Strattigize until the Client's subscription
              has been active for a minimum of 12 consecutive months, after
              which ownership of client-specific Deliverables may be transferred
              upon written request.
            </p>
            <p data-id="element-721">
              The Company retains the right to use anonymised versions of
              Deliverables for portfolio, marketing, and promotional purposes.
            </p>
          </section>

          <section data-id="element-722">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-723">
              7. Client Obligations
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-724">
              <li data-id="element-725">
                Provide accurate and complete information necessary for the
                delivery of Services.
              </li>
              <li data-id="element-726">
                Respond to communications and requests for approval within a
                reasonable timeframe.
              </li>
              <li data-id="element-727">
                Ensure that all content provided to us does not infringe upon
                any third-party intellectual property rights.
              </li>
              <li data-id="element-728">
                Not engage in any activity that may disrupt, damage, or
                interfere with the Services.
              </li>
              <li data-id="element-729">
                Comply with all applicable laws and regulations, including the
                Information Technology Act, 2000 and its amendments.
              </li>
            </ul>
          </section>

          <section data-id="element-730">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-731">
              8. Limitation of Liability
            </h2>
            <p data-id="element-732">
              To the maximum extent permitted by applicable Indian law, the
              Company shall not be liable for any indirect, incidental, special,
              consequential, or punitive damages, including but not limited to
              loss of profits, data, business opportunities, or goodwill,
              arising out of or in connection with the use of our Services.
            </p>
            <p data-id="element-733">
              The Company's total aggregate liability for any claims arising
              under these Terms shall not exceed the total amount paid by the
              Client in the three (3) months immediately preceding the event
              giving rise to the claim.
            </p>
          </section>

          <section data-id="element-734">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-735">
              9. Disclaimer of Warranties
            </h2>
            <p data-id="element-736">
              Services are provided on an "as is" and "as available" basis. The
              Company makes no warranties, express or implied, regarding the
              merchantability, fitness for a particular purpose, or
              non-infringement of the Services. We do not guarantee specific
              results, revenue increases, or lead generation outcomes.
            </p>
          </section>

          <section data-id="element-737">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-738">
              10. Data Protection &amp; Privacy
            </h2>
            <p data-id="element-739">
              We collect, process, and store personal data in accordance with
              the Information Technology (Reasonable Security Practices and
              Procedures and Sensitive Personal Data or Information) Rules,
              2011, and the Digital Personal Data Protection Act, 2023 (as
              applicable). By using our Services, you consent to the collection
              and processing of your data as described in our Privacy Policy.
            </p>
          </section>

          <section data-id="element-740">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-741">
              11. Termination
            </h2>
            <p data-id="element-742">
              Either party may terminate the subscription by providing written
              notice (email to strattigize@gmail.com) at least 7 days before the
              next billing cycle. Upon termination:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-743">
              <li data-id="element-744">
                Access to all Services, including websites, automations, and AI
                tools, will be revoked at the end of the current billing period.
              </li>
              <li data-id="element-745">
                No partial refunds will be issued for the remaining days of the
                current billing cycle.
              </li>
              <li data-id="element-746">
                The Company may retain Client data for up to 30 days after
                termination, after which it may be permanently deleted.
              </li>
            </ul>
          </section>

          <section data-id="element-747">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-748">
              12. Dispute Resolution
            </h2>
            <p data-id="element-749">
              Any dispute, controversy, or claim arising out of or relating to
              these Terms shall first be attempted to be resolved through
              amicable negotiation. If unresolved within 30 days, the dispute
              shall be referred to arbitration in accordance with the
              Arbitration and Conciliation Act, 1996, as amended. The seat of
              arbitration shall be India, and the proceedings shall be conducted
              in English.
            </p>
          </section>

          <section data-id="element-750">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-751">
              13. Governing Law &amp; Jurisdiction
            </h2>
            <p data-id="element-752">
              These Terms shall be governed by and construed in accordance with
              the laws of the Republic of India. Any legal proceedings arising
              out of or in connection with these Terms shall be subject to the
              exclusive jurisdiction of the courts in India.
            </p>
          </section>

          <section data-id="element-753">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-754">
              14. Force Majeure
            </h2>
            <p data-id="element-755">
              The Company shall not be liable for any failure or delay in
              performing its obligations where such failure or delay results
              from circumstances beyond its reasonable control, including but
              not limited to natural disasters, pandemics, government actions,
              internet outages, cyberattacks, or acts of God.
            </p>
          </section>

          <section data-id="element-756">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-757">
              15. Amendments
            </h2>
            <p data-id="element-758">
              The Company reserves the right to amend these Terms at any time.
              Updated Terms will be posted on our website with the revised date.
              Continued use of the Services after any amendment constitutes
              acceptance of the updated Terms.
            </p>
          </section>

          <section data-id="element-759">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-760">
              16. Severability
            </h2>
            <p data-id="element-761">
              If any provision of these Terms is held to be invalid or
              unenforceable by a court of competent jurisdiction, the remaining
              provisions shall continue in full force and effect.
            </p>
          </section>

          <section data-id="element-762">
            <h2 className="text-lg md:text-xl font-bold text-black mb-3" data-id="element-763">
              17. Contact Information
            </h2>
            <p data-id="element-764">
              For any questions or concerns regarding these Terms, please
              contact us at:
            </p>
            <p className="font-medium text-black" data-id="element-765">
              Strattigize
              <br data-id="element-766" />
              Email: strattigize@gmail.com
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-767">
          <button onClick={goBack} className="flex items-center gap-2 text-sm font-bold text-primary hover:text-primary/80 transition-colors" data-id="element-768">
            <ArrowLeftIcon size={16} data-id="element-769" />
            Back to Home
          </button>
        </div>
      </div>
    </div>;
}